import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { UserMinus, ChartBar, Plus, Calendar, BellMinus, Pill, ChartPie, ClockAlert, ShieldUser } from 'lucide-react';
import { CircularProgress, Snackbar, Alert } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; 
import { IconUserCode } from '@tabler/icons-react';
import Absence from '../../components/tables/Absence.jsx';
import { useRef } from 'react';
import {getAllEmployees} from '../../services/EmployeeService';
import AbsenceForm from '../../components/Forms/AbsenceForm';
import Employee from '../../assets/employee.gif';
import EmployeeCard from '../../components/lists/EmplyeeList.jsx'; 
import PageHeader from '../../components/headers/Header'
import AbsenceDetailsModal from '../../components/DViews/AbsenceDetailsModal';
import AbsenceCalendar from '../../components/calendars/AbsenceCalendar';
import DayDetailsModal from '../../components/DViews/CDayDetails.jsx';
import AbsenceDashboard from '../../components/dash/AbsenceDash';
import JustificationUploadModal from '../../components/DViews/JUModal.jsx';
import AbsenceKPIDashboard from '../../components/KPIDashs/AbsenceKPI.jsx';

import {getAllAbsences, getMyAbsences, getAllStagedAbsences, deleteAbsence} from '../../services/absenceAPIs';
import { exportToPdf } from '../../utils/exportToPdf'; 
import { useMediaQuery, Fab, Typography, Box } from '@mui/material';

import '../../components/leaves/Leaves.css';

const NotEmployee = localStorage.getItem('userRole')!=='EMPLOYEE';

const AbsenceManagement = () => {
  const location = useLocation(); // Get location
  const queryParams = new URLSearchParams(location.search);
  const isPersonalParam = queryParams.get('personal') === 'true';

  const [IsEmployee, setIsEmployee] = useState(
    isPersonalParam ||
    localStorage.getItem('userRole') === 'EMPLOYEE' ||
    localStorage.getItem('userRole') === 'DEV'
  );

  const [stagedAbsences, setStagedAbsences]= useState([]);

  const dashboardRef = useRef(null);
  const absencesRef = useRef(null);
  const calendarRef = useRef(null);
  const unconfirmedAbsencesRef= useRef(null);
  const addRef = useRef(null);

  console.log(localStorage.getItem('token'));
  const isLargeScreen = useMediaQuery('(min-width: 1600px)');

  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedAbsence, setSelectedAbsence]= useState(null);
  const [employees, setEmployees] = useState([]);
  const [sickAbsences, setSickAbsences] = useState([]);
  const [lateAbsences, setLateAbsences] = useState([]);
  const [personalAbsences, setPersonalAbsences] = useState([]);

  const [currentDate] = useState(new Date('2025-06-19T10:26:00+01:00'));
  // const [activeTab, setActiveTab] = useState('overview');
  const [activeTab, setActiveTab] = useState(IsEmployee ? 'add' : 'overview');
  const [showEmployeeCard, setShowEmployeeCard] = useState(false);

  // Calendar specific states
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [dayAbsences, setDayAbsences] = useState([]);
  const [showDayDetailsModal, setShowDayDetailsModal] = useState(false);

  const [selectedUpload, setSelectedUpload] = useState(null);

  // Initialize filters with potential state from navigation
  const initialFilters = {
    type: '',
    status: '',
    department: '',
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    search: '',
    includeLateness: true
  };

  const [filters, setFilters] = useState(initialFilters);
   
  
  // PDF states
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    const state = location.state || {};
    setActiveTab(state.targetTab || (IsEmployee ? 'add' : 'overview'));

    if (state.filters) {
      setFilters(prevFilters => ({
        ...prevFilters,
        year: state.filters.year || prevFilters.year,
        month: state.filters.month || prevFilters.month,
        office:
          state.filters.office === 'all'
            ? ''
            : state.filters.office || prevFilters.office,
      }));
    }
    if (state.targetTab) delete state.targetTab;
  }, [location.state, IsEmployee]);

  const handleExportPdf = async () => {
    setIsExporting(true);
    setExportError(null);
    
    let elementId = '';
    let options = {
      filename: `absence-${activeTab}.pdf`,
      ignoreElements: ['.page-header', '.Leaves-nav-tabs', '.MuiModal-root'],
      scale: 1.5,
      margin: 10,
      isCalendar: activeTab === 'calendar',
      onStart: () => setIsExporting(true),
      onComplete: () => setIsExporting(false),
      onError: (message) => {
        setExportError(message);
        setSnackbarOpen(true);
      },
      autoHeight: true,
    };

    switch(activeTab) {
      case 'overview':
        elementId = 'dashboard-container';
        break;
      case 'absences':
        elementId = 'absences-container';
        break;
      case 'calendar':
        elementId = 'calendar-container';
        options.scale = 1.2;
        break;
      case 'add':
        elementId = 'add-container';
        break;
      case 'unconfirmed':
        elementId = 'unconfirmed-absences-container';
        break;
      default:
        elementId = 'dashboard-container';
    }

    await exportToPdf(elementId, options);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  
  const handleEmployeeSelect = (id) => {
    setSelectedEmployeeId(id);
    setShowEmployeeCard(false);
    console.log('Selected employee ID:', id);
  };

  // Handle calendar date click
  const handleCalendarDateClick = (date, absencesForDay) => {
    setSelectedCalendarDate(date);
    setDayAbsences(absencesForDay);
    setShowDayDetailsModal(true);
  };
  
  // Data fetching
  useEffect(() => {
    const fetchData = async () => {
      try {
        const allEmployees = await getAllEmployees();
        setEmployees(allEmployees);
        console.log("All Employees:", allEmployees);
        console.log("All Employees:", employees);
  
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      };
    fetchData();
  }, []);

  const [absences, setAbsences] = useState([]);

  const fetchAbsences = async () => {
    try {
      let data=[];
      const stagedAbsencesData=await getAllStagedAbsences();
      if (IsEmployee) {
        data = await getMyAbsences();
      } else {
        data = await getAllAbsences();
      }
      setAbsences(data);
      setStagedAbsences(stagedAbsencesData);
      setSickAbsences(data.filter(abs => abs.ty_pe === 'SICKNESS'));
      setLateAbsences(data.filter(abs => abs.ty_pe === 'LATENESS'));
      setPersonalAbsences(data.filter(abs => abs.ty_pe === 'PERSONAL'));
      console.log('Absence management absences:', data);
    } catch (error) {
      console.error('Error fetching absences:', error);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchAbsences();
  }, [IsEmployee]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isPersonalParam = queryParams.get('personal') === 'true';
    setIsEmployee(
      isPersonalParam ||
      localStorage.getItem('userRole') === 'EMPLOYEE' ||
      localStorage.getItem('userRole') === 'DEV'
    );
  }, [location.search]);


  useEffect(() => {
    if (IsEmployee && activeTab === 'overview') {
      setActiveTab('add'); // or 'absences', depending on your desired default
    } else if (!IsEmployee && activeTab === 'add') {
      setActiveTab('overview'); // Set to 'overview' when switching to non-employee
    }
  }, [IsEmployee]);

  

  return (
    <div className="Leaves-main-container">
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {exportError || 'Failed to export PDF'}
        </Alert>
      </Snackbar>
      <div className="Leaves-content-wrapper">
        {/* <div className="Leaves-header-section">
          <h1 className="Leaves-title">Absence Management</h1>
          <p className="Leaves-subtitle"></p>
        </div> */}
        <PageHeader 
        title={!IsEmployee ? "Absence Management" : "Management of your absences"}
        subtitle={!IsEmployee ? "Manage & track employees absence" : "Keep track of your absence"}
        
          // actions={
          //   <Box sx={{ position: 'relative', display:'flex', gap:'10px' }}>
          //     <button 
          //       onClick={handleExportPdf}
          //       disabled={isExporting}
          //       style={{
          //         padding: '8px 16px',
          //         backgroundColor: 'transparent',
          //         color: '#3d52a0',
          //         border: '1px solid #3d52a0',
          //         borderRadius: '8px',
          //         fontSize: '14px',
          //         fontWeight: '500',
          //         cursor: 'pointer',
          //         display: 'flex',
          //         alignItems: 'center',
          //         opacity: isExporting ? 0.7 : 1
          //       }}
          //     >
          //       {isExporting ? (
          //         <>
          //           <CircularProgress size={20} thickness={4} sx={{ color: '#3d52a0', mr: 1 }} />
          //           Exporting...
          //         </>
          //       ) : (
          //         <>
          //           <PictureAsPdfIcon fontSize="small" sx={{ mr: 1 }} />
          //           Export
          //         </>
          //       )}
          //     </button>
          //     {(NotEmployee &&
          //       <button
          //         onClick={() => setIsEmployee(!IsEmployee)}
          //         // disabled={isExporting}
          //         style={{
          //           padding: '8px 16px',
          //           backgroundColor: 'transparent',
          //           color: '#3d52a0',
          //           border: '1px solid #3d52a0',
          //           borderRadius: '8px',
          //           fontSize: '14px',
          //           fontWeight: '500',
          //           cursor: 'pointer',
          //           display: 'flex',
          //           alignItems: 'center',
          //           opacity: isExporting ? 0.7 : 1
          //         }}
          //       >
          //       <IconUserCode style={{ color: '#3d52a0', margin: 'auto', marginRight: '6px' }} />
          //       {IsEmployee ? 'General Portal' : 'Personal Portal'}
          //     </button>
          //      )}
          //   </Box>
          // }
        />
                
        <div className="Leaves-nav-tabs">
          <div className="Leaves-tab-bar">
            {[
               ...(!IsEmployee ? [{ id: 'kpi', name: 'KPI' , icon: ChartPie }] : []),
               ...(!IsEmployee ? [{ id: 'overview', name: 'Overview', icon: ChartBar }] : []),
              { id: 'absences', name: 'Absences', icon: UserMinus },
              ...(!IsEmployee ? [{ id: 'sickAbsences', name: 'Sickness', icon: Pill }] : []),
              ...(!IsEmployee ? [{ id: 'late', name: 'Lateness', icon: ClockAlert }] : []),
              ...(!IsEmployee ? [{ id: 'personal', name: 'Personal Commitments', icon: ShieldUser }] : []),
              // { id: 'calendar', name: 'Calendar', icon: Calendar },
              { id: 'add', name: IsEmployee ? 'Notify About Absence' : 'Add Absence', icon: Plus },
              { id: 'addLate', name: IsEmployee ? 'Notify About Lateness' : 'Add Lateness', icon: Plus },
              ...(!IsEmployee ? [{ id: 'unconfirmed', name: 'Unconfirmed Absences', icon: BellMinus }] : []),
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`Leaves-tab-btn ${activeTab === tab.id ? 'Leaves-tab-btn-active' : ''}`}
              >
                <tab.icon className="Leaves-tab-icon" />
                {tab.name}
              </button>
            ))}
          </div>
        </div>
        {activeTab === 'kpi' && (< AbsenceKPIDashboard />)}
        {activeTab === 'overview' && (
          <div id="dashboard-container" ref={dashboardRef}>
            <AbsenceDashboard IMGemployees={employees} />
          </div>
        )}
        {activeTab === 'absences' && (
          <div id="absences-container" ref={absencesRef}>
          <Absence
            filters={filters}
            setFilters={setFilters}
            setSelectedAbsence={setSelectedAbsence}
            absences={absences}
            setSelectedUpload={setSelectedUpload}
            unconfirmed={false}
            fetchAbsences={fetchAbsences}
            IsEmployee={IsEmployee}
            late={true}
          />
          </div>
        )}
        {activeTab === 'late' && (
          <div id="absences-container" ref={absencesRef}>
          <Absence
            filters={filters}
            setFilters={setFilters}
            setSelectedAbsence={setSelectedAbsence}
            absences={lateAbsences}
            setSelectedUpload={setSelectedUpload}
            unconfirmed={false}
            fetchAbsences={fetchAbsences}
            IsEmployee={IsEmployee}
          />
          </div>
        )}
        {activeTab === 'personal' && (
          <div id="absences-container" ref={absencesRef}>
          <Absence
            filters={filters}
            setFilters={setFilters}
            setSelectedAbsence={setSelectedAbsence}
            absences={personalAbsences}
            setSelectedUpload={setSelectedUpload}
            unconfirmed={false}
            fetchAbsences={fetchAbsences}
            IsEmployee={IsEmployee}
          />
          </div>
        )}
        {activeTab === 'sickAbsences' && (
          <div id="absences-container" ref={absencesRef}>
          <Absence
            filters={filters}
            setFilters={setFilters}
            setSelectedAbsence={setSelectedAbsence}
            absences={sickAbsences}
            setSelectedUpload={setSelectedUpload}
            unconfirmed={false}
            fetchAbsences={fetchAbsences}
            IsEmployee={IsEmployee}
          />
          </div>
        )}

        {activeTab === 'unconfirmed' && (
          <div id="unconfirmed-absences-container" ref={unconfirmedAbsencesRef}>
          <Absence
            filters={filters}
            setFilters={setFilters}
            setSelectedAbsence={setSelectedAbsence}
            absences={stagedAbsences}
            setSelectedUpload={setSelectedUpload}
            unconfirmed={true}
            fetchAbsences={fetchAbsences}
          />
          </div>
        )}

        {/* {activeTab === 'analytics' && <Analytics />} */}
        {activeTab === 'add' && !IsEmployee &&
         <Typography variant="h4" gutterBottom sx={{ mb: 1, ml:2.5 , fontWeight: 'bold', color: '#c01557' }}>
          👤 Don't forget to choose the employee
         </Typography>
        }
        {isLargeScreen ? (
        <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'add' && employees.length>0 && !IsEmployee && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={3}/>}
          {activeTab === 'add' && <AbsenceForm IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
        </div>
        ) : (
          <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'add' && !IsEmployee &&
            <Fab
                onClick={() => setShowEmployeeCard(!showEmployeeCard)}
                sx={{
                  position: 'fixed',
                  bottom: 20,
                  right: 20,
                  zIndex: 1000,
                  backgroundColor: 'var(--card-bg, white)',
                  boxShadow: 3,
                }}
                  >
                  <img
                    src={Employee}
                    alt="Employee"
                    style={{ width: '40px', height: '35px', borderRadius:'5px' }} // Adjust size as needed
                    />   
                </Fab>
                } 
                {showEmployeeCard && (
                  <Box
                    sx={{
                    position: 'fixed',
                    bottom: 15,
                    right: 100,
                    width: '90%',
                    maxWidth: 500,
                    zIndex: 1000,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: 'var(--card-bg, white)',
                    p: 2,
                  }}
                  >
                    {activeTab === 'add' && employees.length>0 && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={2}/>}
                  </Box>
                      )}

                {activeTab === 'add' && <AbsenceForm IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
            </div>

        )}       

        {/* {activeTab === 'analytics' && <Analytics />} */}
        {activeTab === 'addLate' && !IsEmployee &&
         <Typography variant="h4" gutterBottom sx={{ mb: 1, ml:2.5 , fontWeight: 'bold', color: '#c01557' }}>
          👤 Don't forget to choose the employee
         </Typography>
        }
        {isLargeScreen ? (
        <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'addLate' && employees.length>0 && !IsEmployee && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={3}/>}
          {activeTab === 'addLate' && <AbsenceForm Lateness={true} IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
        </div>
        ) : (
          <div style={{display: 'flex', gap: '16px'}}>
          {activeTab === 'addLate' && !IsEmployee &&
            <Fab
                onClick={() => setShowEmployeeCard(!showEmployeeCard)}
                sx={{
                  position: 'fixed',
                  bottom: 20,
                  right: 20,
                  zIndex: 1000,
                  backgroundColor: 'var(--card-bg, white)',
                  boxShadow: 3,
                }}
                  >
                  <img
                    src={Employee}
                    alt="Employee"
                    style={{ width: '40px', height: '35px', borderRadius:'5px' }} // Adjust size as needed
                    />   
                </Fab>
                } 
                {showEmployeeCard && (
                  <Box
                    sx={{
                    position: 'fixed',
                    bottom: 15,
                    right: 100,
                    width: '90%',
                    maxWidth: 500,
                    zIndex: 1000,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: 'var(--card-bg, white)',
                    p: 2,
                  }}
                  >
                    {activeTab === 'addLate' && employees.length>0 && <EmployeeCard employees={employees}  onSelectEmployee={handleEmployeeSelect} itemsPerPage={2}/>}
                  </Box>
                )}

                {activeTab === 'addLate' && <AbsenceForm Lateness={true} IsEmployee={IsEmployee} fetchAbsences={fetchAbsences} employeeId={selectedEmployeeId} employees={employees} />}
            </div>

        )}     
        

        {selectedAbsence && (
          <AbsenceDetailsModal
            selectedAbsence={selectedAbsence}
            setSelectedAbsence={(val) => {
            //console.log('Set selectedAbsence to:', val); // Debug
            setSelectedAbsence(val);
            }}
            fetchAbsences={fetchAbsences}
            IsEmployee={IsEmployee}
          />
        )}
        
        {selectedUpload && (
          <JustificationUploadModal
            selectedUpload={selectedUpload}
            setSelectedUpload={(val) => {
            setSelectedUpload(val);
            }}
            fetchAbsences={fetchAbsences}
          />
        )} 

        {/* Calendar Tab */}
        {activeTab === 'calendar' && (
          <Box id="calendar-container" sx={{ padding: '16px' }} ref={calendarRef}>
            <AbsenceCalendar
              absences={absences}
              onDateClick={handleCalendarDateClick}
              currentDate={currentDate}
            />
          </Box>
        )}

        {/* Day Details Modal for Calendar */}
        <DayDetailsModal
          open={showDayDetailsModal}
          onClose={() => setShowDayDetailsModal(false)}
          selectedDate={selectedCalendarDate}
          dayAbsences={dayAbsences}
          employees={employees}
        />
        
      </div>
    </div>
  );
};

export default AbsenceManagement;
